//
// map.js
//

const maps = document.querySelectorAll('[data-map]');
const accessToken = 'pk.eyJ1IjoiZ2lvdmFubmlhbG9saXZlaXJhIiwiYSI6ImNra3FtbnY2NzM2OHkyd3BkZTRvdWJkbHYifQ.m0h0J-PcethHZMkLmsAkEQ';

if (typeof mapboxgl !== 'undefined') {
    maps.forEach(map => {
        const elementOptions = map.dataset.map ? JSON.parse(map.dataset.map) : {};

        const defaultOptions = {
            container: map,
            style: 'mapbox://styles/mapbox/streets-v11'
        }

        const options = {
            ...elementOptions,
            ...defaultOptions
        };

        // Get access token
        mapboxgl.accessToken = accessToken;

        // Init map
        const mapInstance = new mapboxgl.Map(options);

        if (map.dataset.marker != undefined) {
            new mapboxgl.Marker({
                color: 'red',
            }).setLngLat(map.dataset.marker.split(', ')).addTo(mapInstance);
        }
    })
}
